import { QueryFunctionContext } from '@tanstack/react-query';
import { api } from '../services/api';
import { IData } from '../types/shared';

export interface ISocioGov {
  id: number;
  nome: string;
  cpf: string;
  socio_desde: string;
  cargo: string;
}

export interface ISocioDominio {
  id: number;
  codi_socio: string;
  nome_socio: string;
  cpf: string;
  participacao: number;
  qt_cotas: number;
  data_ingresso: string;
  data_saida: string | null;
}

export interface IEmpresaAnaliseSocios {
  empresa_id: number;
  cnpj: string;
  razao_social: string;
  qtd_socios_dominio: number;
  qtd_socios_gov: number;
  diferenca: number;
  status: 'divergente' | 'convergente' | 'sem_dados_gov';
  socios_dominio: ISocioDominio[];
  socios_gov: ISocioGov[];
  socios_faltantes_dominio: ISocioGov[];
}

export interface ITotalizadoresAnaliseSocios {
  total_empresas_analisadas: number;
  total_com_dados_gov: number;
  total_divergentes: number;
  total_convergentes: number;
  total_sem_dados_gov: number;
  total_sem_dados_dominio: number;
  total_dominio_maior: number;
  total_gov_maior: number;
  percentual_convergencia: number;
  percentual_divergencia: number;
  percentual_sem_dados_gov: number;
  percentual_sem_dados_dominio: number;
}

export type StatusFilterAnaliseSocios =
  | 'divergentes'
  | 'convergentes'
  | 'sem_dados_gov'
  | 'sem_dados_dominio'
  | 'todas';

export const useAnaliseSocios = () => {
  const getEmpresasAnaliseSocios = async (
    key: QueryFunctionContext,
  ): Promise<IData<IEmpresaAnaliseSocios[]>> => {
    const filters = key.queryKey?.[1] ?? {};
    const res = await api.get<IData<IEmpresaAnaliseSocios[]>>('/api/v1/analise-socios/empresas', {
      params: filters,
    });
    return res.data;
  };

  const getTotalizadoresAnaliseSocios = async (): Promise<ITotalizadoresAnaliseSocios> => {
    const res = await api.get<{ data: ITotalizadoresAnaliseSocios }>(
      '/api/v1/analise-socios/totalizadores',
    );
    return res.data.data;
  };

  return {
    getEmpresasAnaliseSocios,
    getTotalizadoresAnaliseSocios,
  };
};
